import { isCurrentPageSel } from '@location';
import { ROUTE_REPORTS } from '@shared/duck/actions';

import { ROUTE_ROLES } from '../../roles';
import { ROUTE_SETTINGS } from '../../settings';
import { moduleName } from '../constants';

const settingsRoutes = [ROUTE_ROLES, ROUTE_SETTINGS];
const reportsRoutes = [ROUTE_REPORTS];

export const isSettingsRouteSel = state =>
  isCurrentPageSel(state, ...settingsRoutes);
export const isReportsRouteSel = state =>
  isCurrentPageSel(state, ...reportsRoutes);

const moduleSel = state => state[moduleName];

export const updateAppSel = state => moduleSel(state).updateApp;
export const updatingAppSel = state => moduleSel(state).updatingApp;

export {
  appBootstrappedSel,
  sidebarOpenSel,
  sidebarExpandedSel,
  headerVisibleSel,
} from '@shared';
